import ReactSignatureCanvas from "react-signature-canvas";
import SignaturePad from "react-signature-canvas";

import { styled } from "simplydo/react/styled";
import { Segment } from "simplydo/react/ui";

const CanvasContainer = styled(Segment)`
  background-color: #fff;
  padding: 0px !important;
`;

const ClearText = styled.span`
  color: gray;
  text-decoration-line: underline;
  margin: 5px 0;
  display: block;
  cursor: pointer;
`;

type SignatureCanvasProps = {
  canvasRef: React.RefObject<ReactSignatureCanvas | null>;
  width?: string;
  height?: string;
};

const SignatureCanvas = ({
  canvasRef,
  width = "100%",
  height = "30px",
}: SignatureCanvasProps) => (
  <div>
    <CanvasContainer style={{ width, height }}>
      <SignaturePad ref={canvasRef} canvasProps={{ width, height }} />
    </CanvasContainer>
    <ClearText onClick={() => canvasRef.current?.clear()}>
      Clear signature
    </ClearText>
  </div>
);

export default SignatureCanvas;
